import { inject, Injectable } from '@angular/core';
import { NetzbetreiberTeilgebieteInfo } from '../../auth/netzbetreiber-teilgebiete-info';
import { AuthenticationService } from '../../auth/authentication.service';
import { StorageService } from '../storage/storage.service';

@Injectable({
    providedIn: 'root',
})
export class TeilgebietSelectionService {

    private selectedStwId?: string;

    private authService = inject(AuthenticationService);
    private storageService = inject(StorageService);

    public getAvailableTeilgebiete(): NetzbetreiberTeilgebieteInfo[] | undefined {
        return this.authService.user?.teilgebieteInfos;
    }

    public hasTeilgebiete(): boolean {
        const teilgebiete = this.getAvailableTeilgebiete();
        return teilgebiete != null && teilgebiete.length > 0;
    }

    public hasMultipleTeilgebiete(): boolean {
        const teilgebiete = this.getAvailableTeilgebiete();
        return teilgebiete != null && teilgebiete.length > 1;
    }

    public getSelectedTeilgebiet(): NetzbetreiberTeilgebieteInfo | undefined {
        const stwId = this.getSelectedStadtwerkeId();
        return this.getAvailableTeilgebiete()?.find(value => value.stadtwerkeId === stwId);
    }

    public getSelectedStadtwerkeId(): string | undefined {
        if (!this.selectedStwId) {
            this.selectedStwId = this.storageService.getPreselectedTeilgebietStwId();
        }
        if (!this.selectedStwId) {
            this.selectedStwId = this.getAvailableTeilgebiete()?.[0]?.stadtwerkeId;
        }
        return this.selectedStwId;
    }

    public setSelectedTeilgebiet(teilgebieteInfo: NetzbetreiberTeilgebieteInfo) {
        this.setSelectedTeilgebietViaStadtwerkeId(teilgebieteInfo.stadtwerkeId);
    }

    public setSelectedTeilgebietViaStadtwerkeId(stadtwerkeId: string) {
        this.selectedStwId = stadtwerkeId;
        this.storageService.setPreselectedTeilgebietStwId(stadtwerkeId);
    }

    public resetSelection() {
        this.storageService.deletePreselectedTeilgebietStwId();
        this.selectedStwId = undefined;
    }
}
